/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Fr2_BodyInputs */

const en_funnel_sq_fr2_body = /** @type {(inputs: Funnel_Sq_Fr2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only need the abstract or the results? Jump straight there. Listening understands the structure of a paper, so you choose exactly what to hear, and it skips citations and footnotes as it reads.`)
};

const es_funnel_sq_fr2_body = /** @type {(inputs: Funnel_Sq_Fr2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Solo necesitas el resumen o los resultados? Ve directo ahí. Listening entiende la estructura de un artículo, así que eliges exactamente qué escuchar, y omite las citas y las notas al pie mientras lee.`)
};

/**
* | output |
* | --- |
* | "Only need the abstract or the results? Jump straight there. Listening understands the structure of a paper, so you choose exactly what to hear, and it skips ..." |
*
* @param {Funnel_Sq_Fr2_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_fr2_body = /** @type {((inputs?: Funnel_Sq_Fr2_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Fr2_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_fr2_body(inputs)
	return en_funnel_sq_fr2_body(inputs)
});